import React from 'react'
import { Menu, MenuItem, TextField } from '@mui/material'
import { translate } from 'utils/propKeysTranslations'
import { useField } from 'formik'

const ITEM_HEIGHT = 48

function InputOrSelect({
  fieldName,
  data,
  endpoint,
  ...props
}) {
  const [field, meta, { setValue: onOptionClick }] = useField({ name: fieldName, ...props })
  const isInvalid = !!meta.touched && !!meta.error
  const options = data?.map?.(({ name }) => name) || []
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const handleFocus = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOptionClick = async (newValue) => {
    onOptionClick(newValue, true)
    handleClose()
  }

  return (
    <div className='w-full' >
      <label
        className='block text-gray-700 text-sm font-bold pt-2 pb-1'
        htmlFor={fieldName}
      >
        {translate(fieldName)}
      </label>
      <TextField
        className='z-0'
        fullWidth
        error={isInvalid}
        {...field}
        value={field.value || ''}
        type='text'
        onClick={handleFocus}
      />
      {options.length && (
        <Menu
          className='overflow-visible block'
          disableAutoFocus
          autoFocus={false}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onBlur={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          PaperProps={{
            elevation: 3,
            sx: { marginTop: '-2px', maxHeight: ~~(ITEM_HEIGHT * 5.2) },
          }}
        >
          {options.map((value) => (
            <MenuItem
              key={value}
              onClick={() => handleOptionClick(value)}
            >
              {value}
            </MenuItem>
          ))}
        </Menu>
      )}
      {isInvalid && <div className='text-red-500 text-sm'>{meta.error}</div>}
    </div>
  )
}

export default InputOrSelect
